/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BundlingSettingsInputEnum {
    PARTS_BUNDLING = 'PARTS_BUNDLING',
    PERIODICITY = 'PERIODICITY',
    PERIOD_DAYS_OFFSET = 'PERIOD_DAYS_OFFSET',
    PERIOD_MAX_BUNDLES = 'PERIOD_MAX_BUNDLES',
    BUNDLE_MAX_VALUE = 'BUNDLE_MAX_VALUE',
    BUNDLE_AGGREGATION = 'BUNDLE_AGGREGATION',
    LINE_AGGREGATION = 'LINE_AGGREGATION',
    MAX_BUNDLE_LINES = 'MAX_BUNDLE_LINES'
}
